"use client";
import { useState, useEffect, useCallback } from "react";
import Particles from "react-tsparticles";
import type { Engine } from "tsparticles-engine";
import { loadSlim } from "tsparticles-slim";

export default function ParticlesBackground() {
  const particlesInit = useCallback(async (engine: Engine) => {
    await loadSlim(engine);
  }, []);

  const [dotColor, setDotColor] = useState("#999");

  useEffect(() => {
    function readColor() {
      const color = getComputedStyle(document.documentElement)
        .getPropertyValue("--uforeground2")
        .trim();
      if (color) setDotColor(color);
    }
    readColor();

    // Re-read whenever the theme class changes on <html>
    const observer = new MutationObserver(readColor);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return (
    <Particles
      key={dotColor}
      init={particlesInit}
      options={{
        fullScreen: {
          enable: true,
          zIndex: -1,
        },
        particles: {
          number: {
            value: 120,
            density: { enable: true, area: 800 },
          },
          color: { value: dotColor },
          size: { value: 2 },
          opacity: { value: 0.5 },
          move: {
            enable: true,
            speed: 0.4,
          },
          links: {
            enable: true,
            distance: 120,
            color: dotColor,
            opacity: 0.2,
            width: 1,
          },
        },
        interactivity: {
          events: {
            onHover: {
              enable: true,
              mode: "grab",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 150,
              links: { opacity: 0.15 },
            },
          },
        },
      }}
    />
  );
}
